import { useEffect, useState } from "react";
import api from "./api";

// Fetch protected image as blob URL
export const useAuthImage = (storagePath) => {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        if (!storagePath) {
            setSrc(null);
            return;
        }
        let revoked = null;
        let cancelled = false;
        (async () => {
            try {
                const resp = await api.get(`/files/${storagePath}`, { responseType: "blob" });
                if (cancelled) return;
                const url = URL.createObjectURL(resp.data);
                revoked = url;
                setSrc(url);
            } catch (e) {
                if (!cancelled) setSrc(null);
            }
        })();
        return () => {
            cancelled = true;
            if (revoked) URL.revokeObjectURL(revoked);
        };
    }, [storagePath]);

    return src;
};

export const fetchImageDataUrl = async (storagePath) => {
    if (!storagePath) return null;
    try {
        const resp = await api.get(`/files/${storagePath}`, { responseType: "blob" });
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(resp.data);
        });
    } catch (e) {
        return null;
    }
};
